import { render } from "./Config.vue?vue&type=template&id=5d749933&scoped=true&ts=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=5d749933&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d749933"]])

export default __exports__